/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description <p>Возможные значения:</p>\n<ul>\n<li><b>1 - Music</b>: Музыкальный альбом</li>\n<li><b>2 - Podcast</b>: Альбом подкастов</li>\n<li><b>3 - Book</b>: Альбом книг</li>\n<li><b>4 - Sermon</b>: Альбом проповедей</li>\n</ul>\n
 */
export const albumTypeEnumSchema = z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)]).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>1 - Music</b>: Музыкальный альбом</li>\n<li><b>2 - Podcast</b>: Альбом подкастов</li>\n<li><b>3 - Book</b>: Альбом книг</li>\n<li><b>4 - Sermon</b>: Альбом проповедей</li>\n</ul>\n")